import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import api from '../services/api';

// Rotas onde o carrinho flutuante aparece
const CART_PATHS = ['/', '/produtos', '/carrinho'];
function showOnPath(pathname) {
  return CART_PATHS.includes(pathname) || pathname.startsWith('/produto/');
}

export default function FloatingCart() {
  const location = useLocation();
  const [count, setCount] = useState(0);

  useEffect(() => {
    api.get('/cart')
      .then(r => setCount((r.data.carrinho || []).reduce((s, i) => s + (i.quantidade || 1), 0)))
      .catch(() => {});
  }, []);

  if (!showOnPath(location.pathname)) return null;

  return (
    <Link
      to="/carrinho"
      title="Carrinho"
      style={{
        position: 'fixed',
        bottom: 28,
        right: 28,
        width: 56,
        height: 56,
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #1e90ff, #16c2fb)',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.35rem',
        boxShadow: '0 6px 20px rgba(30,144,255,0.45)',
        textDecoration: 'none',
        zIndex: 98,
        transition: 'transform 0.2s, box-shadow 0.2s',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'scale(1.12)';
        e.currentTarget.style.boxShadow = '0 10px 28px rgba(30,144,255,0.55)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(30,144,255,0.45)';
      }}
    >
      <i className="fas fa-shopping-cart" />
      {count > 0 && (
        <span style={{
          position: 'absolute', top: -4, right: -4,
          background: '#ff4757', color: '#fff',
          borderRadius: '50%', width: 22, height: 22,
          fontSize: '0.72rem', fontWeight: 800,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          border: '2px solid #fff', fontFamily: 'Poppins, sans-serif',
        }}>
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  );
}
